export default "__VITE_ASSET__C5TJULvX__"